import React from "react";
import "./MarketingSection.css";

export const MarketingSection = (props) => {
  const handleClick = () => {
    props.sendData(3);
  };
  const handleSelectCheckbox = (e) => {
    let indexIS = props.CheckboxSelect.indexOf(e.target.value);
    if (indexIS === -1) {
      props.setCheckboxSelect([...props.CheckboxSelect, e.target.value]);
    } else {
      let newArray = props.CheckboxSelect.filter(
        (res, index) => index !== indexIS
      );
      props.setCheckboxSelect(newArray);
    }
  };
  const marketing_items = [
    {
      mr_labels: "instagram",
      icon_name: "fa-brands fa-instagram",
      mr_labels_ar: "انستقرام",
    },
    {
      mr_labels: "snapchat",
      icon_name: "fa-brands fa-snapchat",
      mr_labels_ar: "سناب شات",
    },
    {
      mr_labels: "facebook",
      icon_name: "fa-brands fa-facebook",
      mr_labels_ar: "فيس بوك",
    },
    {
      mr_labels: "twitter",
      icon_name: "fa-brands fa-twitter",
      mr_labels_ar: "تويتر",
    },
    {
      mr_labels: "influencers",
      icon_name: "fa-solid fa-users",
      mr_labels_ar: "مؤثرين",
    },
    {
      mr_labels: "i_don’t_do_marketing",
      icon_name: "fa-solid fa-ban",
      mr_labels_ar: "لا اقوم بالتسويق ",
    },
  ];
  return (
    <>
      <h1 className="heading_text mt-5">
        ماهي انواع التسويق التي تستخدمها حاليا :
      </h1>
      <span className="marketing_text">اختار من التالي : </span>
      <div className="d-flex mt-5 marketing_fullbox mx-auto">
        {marketing_items.map((res, index) => {
          return (
            <span className="marketing_boxes" key={index}>
              <input
                id={res.mr_labels}
                name="marketing_boxes"
                type="checkbox"
                value={res.mr_labels_ar}
                className="d-none marketing_checkbox"
                checked={
                  props.CheckboxSelect.indexOf(res.mr_labels_ar) === -1
                    ? false
                    : true
                }
                onChange={handleSelectCheckbox}
              />
              <label
                htmlFor={res.mr_labels}
                className="marketing_labels d-flex flex-column align-items-center"
              >
                <i className={`${res.icon_name} marketing_icons`}></i>{" "}
                {res.mr_labels_ar}
              </label>
            </span>
          );
        })}
      </div>
      <button
        type="button"
        className="input_button button_width"
        disabled={props.CheckboxSelect === "" ? true : false}
        onClick={() => handleClick()}
      >
        المتابعة{" "}
        <i className="fa fa-long-arrow-right ms-2" aria-hidden="true"></i>
      </button>
    </>
  );
};
